var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Announcement"}},_vm._l((_vm.announs),function(item){return _c('v-card',{key:item['_id']['$oid'],staticClass:"ma-3 pa-3 subheading"},[_vm._v("\n      "+_vm._s(item['msg_zh'])+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-deda3086","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Announcement.vue
// module id = 161
// module chunks = 1